import styles from './index.scss'
import React, { useState } from 'react'
import { NoticeSvg } from './svgIcon'
import { RightOutline } from 'antd-mobile-icons'
import classnames from 'classnames'
import { TrackView } from '@dragonpass/intl-unified-tracker'
import DpTracker from '@/libs/components/DpTrackerComponents/DpTracker'
import DpBgTheme from '@/libs/components/DpUiComponents/DpBgTheme'
import DpButtonTheme from '@/libs/components/DpUiComponents/DpButtonTheme'
import DpBusinessPopup from '@/libs/components/DpBusinessComponents/DpBusinessPopup'
import DpRichText from '@/libs/components/DpFunctionComponents/DpRichText'
export type IDpBusinessCommodityNotice = {
  bgType?: string
  title?: string
  tips?: string
  onClick?: any
  styles?: React.CSSProperties
  customStyles?: React.CSSProperties
  detail: string | undefined
  descRender?: (updateVisible: any) => void
  RichTextClassName?: any
  isTheme?: boolean
  hasTrackerPermission?: boolean
  popupProps?: any
  track_module_name?: string
}

const Notice = (props: IDpBusinessCommodityNotice) => {
  const [visible, updateVisible] = useState(false)
  return (
    <>
      {props?.descRender?.(updateVisible) ||
        <DpBgTheme
          type={props?.bgType || 'content'}
          className={styles['dp-business-notice']}
          onClick={() => {
           updateVisible(true)
            if (props?.hasTrackerPermission) {
              window?.dpTracker?.sendClk?.({
                eventData: {
                  module_name: props?.track_module_name || `商品介绍`,
                }
              })
            }
          }}
          style={props?.styles}
        >
          <div className={styles['dp-business-notice-title']}>
            <NoticeSvg />
          </div>
          <div className={styles['dp-business-notice-body']}>
            <div className={styles['dp-business-notice-body--tips']}>
              {props?.tips}
            </div>
            <RightOutline className={styles['dp-business-notice-body--arrows']} />
          </div>
        </DpBgTheme>
      }
      <DpBusinessPopup
        title={props?.title || lang['商品详情']}
        visible={visible}
        onClose={() => updateVisible(!visible)}
        headerStyle={{ borderBottomWidth: 0, color: 'var(--third-text-color)' }}
        titleStyle={{
          color: 'var(--primary-text-color, #202020)',
          textAlign: 'center',
        }}
        popupBodyStyles={{
          ...props?.customStyles,
          background: `var(--page-bg-color)`,
        }}
        containerStyles={{
          background: `var(--content-bg-color, #ffffff)`,
          borderRadius: '16px',
          margin: '0 10px 10px',
        }}
        footer={
          <div className={styles['dp-business-notice-footer']}>
            <DpButtonTheme
              shape="rounded"
              color="primary"
              size="middle"
              style={{
                color: 'var(--button-primary-color, --adm-color-primary)',
              }}
              onClick={() => updateVisible(!visible)}
            >
              {lang['我已知晓']}
            </DpButtonTheme>
          </div>
        }
        footerStyles={{ padding: 0 }}
        popupProps={props?.popupProps}
      >
        {
          props?.hasTrackerPermission ?
            <DpTracker>
              <TrackView
                component="div"
                trackClk={false}
                trackData={{
                  module_name: props?.track_module_name || `商品介绍`,
                }}
                trackExp={true}
                onClick={(e) => {
                  e.stopPropagation()
                }}
              >
                <DpRichText className={ classnames([{[styles["dp-business-notice-theme"]]: !!props?.isTheme}], props?.RichTextClassName)} data={props?.detail} />
              </TrackView>
            </DpTracker>
            :
            <DpRichText className={ classnames([{[styles["dp-business-notice-theme"]]: !!props?.isTheme}], props?.RichTextClassName)} data={props?.detail} />
        }
      </DpBusinessPopup>
    </>
  )
}

export default Notice
